<button [class.disabled]="disabled" class="button {{buttonStyle}}" [class.text-danger]="danger" type="{{type}}" (click)="handleClick()">
@if (icon) {
    <i class="fas fa-{{icon}}" style="vertical-align: middle;"></i>
}    {{text}}
</button>